import React, { useState } from "react"

import "./index.scss"

import { Container, Title, DurationInput, HiddenInput } from "components/Form"
import { ConfigContainer } from "components"

import { Duration } from "luxon"

// Action connection config used in graph design tool.
export default function ActionConnectionConfig({
  connection,
  actionFrom,
  actionTo,
  submitHandler,
  deleteHandler,
  cancelHandler,
}) {
  const [minTimeBetween, setMinTimeBetween] = useState(
    Duration.fromObject({ seconds: (connection && connection.timeBetween && connection.timeBetween.min) || 0 })
  )
  const [maxTimeBetween, setMaxTimeBetween] = useState(
    connection && connection.timeBetween && connection.timeBetween.max !== null
      ? Duration.fromObject({ seconds: connection.timeBetween.max })
      : null
  )
  const [isWorkdayConnection, setIsWorkdayConnection] = useState(connection.isWorkdayConnection)

  return (
    <ConfigContainer
      title={`Edit connection from ${actionFrom.name} to ${actionTo.name}`}
      submitHandler={() => {
        submitHandler({
          timeBetween: {
            min: minTimeBetween.as("seconds"),
            max: maxTimeBetween ? maxTimeBetween.as("seconds") : null,
          },
          isWorkdayConnection
        })
      }}
      deleteHandler={deleteHandler}
      cancelHandler={cancelHandler}
      titleInfoText="Connections are performers only - does not affect asset allocation"
    >
      <Container>
        <Title>Minimum time between actions (DD:HH:MM)</Title>
        <DurationInput required withMinutes value={minTimeBetween} onChange={setMinTimeBetween} />
      </Container>
      <Container>
        <Title>Maximum time between actions (DD:HH:MM)</Title>
        <DurationInput withMinutes value={maxTimeBetween} onChange={setMaxTimeBetween} />
        <em style={{
          color:"grey",
          margin: "0.40em",
        }}>No time limit unless specified</em>
      </Container>
      <Container>
        <Title>Connection calculated in workdays</Title>
        <input
          type="checkbox"
          id="connection-config-checkboxWorkday"
          defaultChecked={isWorkdayConnection}
          onClick={() => {setIsWorkdayConnection(!isWorkdayConnection)}}
        />
      </Container>
      <HiddenInput
        message={
          minTimeBetween && maxTimeBetween && minTimeBetween > maxTimeBetween
            ? "Minimum time between must be smaller than maximum time between"
            : null
        }
      />
    </ConfigContainer>
  )
}
